document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 768) {
        const e = document.querySelectorAll(".icon-bx");
        e.forEach((t) => {
            let n = document.createElement("div");
            n.classList.add("accordion-header");
            let o = t.querySelector("img").cloneNode(!0),
                c = t.querySelector(".customer-bx").innerText,
                l = t.querySelector("img");
            l.parentNode.removeChild(l);
            let a = document.createElement("span");
            (a.classList.add("accordion-toggle"),
                (a.innerText = "+"),
                n.appendChild(o),
                (n.innerHTML += `<span>${c}</span>`),
                n.appendChild(a));
            let d = t.querySelector(".text-with-icons__text-wrapper"),
                i = document.createElement("div");
            (i.classList.add("accordion-content"),
                i.appendChild(d),
                t.prepend(n),
                t.appendChild(i),
                n.addEventListener("click", function () {
                    const n = t.classList.contains("active");
                    (e.forEach((e) => {
                        (e.classList.remove("active"),
                            (e.querySelector(".accordion-toggle").innerText =
                                "+"));
                    }),
                        n || (t.classList.add("active"), (a.innerText = "-")));
                }));
        });
    }
});
var modal = document.getElementById("myModal"),
    btn = document.getElementById("myBtn"),
    span = document.getElementsByClassName("close")[0];
if (btn && modal && span) {
    btn.onclick = function () {
        modal.style.display = "block";
    };
    span.onclick = function () {
        modal.style.display = "none";
    };
    window.onclick = function (e) {
        e.target == modal && (modal.style.display = "none");
    };
}
function disablePastTimes() {
    let e = new Date(),
        t = e.getHours(),
        n = e.getMinutes(),
        o = new Date(document.getElementById("datePicker").value),
        c = new Date(),
        l = document.querySelectorAll(".time-buttons button");
    l.forEach((l) => {
        let [a, d] = l.innerText.split(":").map(Number);
        o.toDateString() === c.toDateString()
            ? a < t || (a === t && d < n) || a === t + 1
                ? (l.classList.add("disabled"),
                  (l.disabled = !0),
                  (l.style.background = "#ddd"),
                  (l.style.cursor = "not-allowed"))
                : (l.classList.remove("disabled"),
                  (l.disabled = !1),
                  (l.style.background = "white"),
                  (l.style.cursor = "pointer"))
            : (l.classList.remove("disabled"),
              (l.disabled = !1),
              (l.style.background = "white"),
              (l.style.cursor = "pointer"));
    });
}
document.addEventListener("DOMContentLoaded", () => {
    let e = document.getElementById("datePicker"),
        t = new Date(),
        n = t.toISOString().split("T")[0];
    ((e.value = n),
        e.setAttribute("min", n),
        disablePastTimes(),
        e.addEventListener("change", disablePastTimes),
        document.querySelectorAll(".time-buttons button").forEach((e) => {
            e.addEventListener("click", function () {
                if (this.classList.contains("disabled")) return;
                (document
                    .querySelectorAll(".time-buttons button")
                    .forEach((e) => {
                        e.classList.contains("disabled") ||
                            (e.classList.remove("selected"),
                            (e.style.background = "white"));
                    }),
                    this.classList.add("selected"),
                    (this.style.background = "yellow"));
            });
        }));
});
document.addEventListener("DOMContentLoaded", function () {
    var e = {
            "pre-book-tygatec-t6-off-road-suv-hoverboard-black-color":
                "pre-book-tygatec-t6-hoverboard",
            "pre-book-tygatec-t6-off-road-suv-hoverboard-red-and-blue-fire-color":
                "pre-book-tygatec-t6-hoverboard",
            "pre-book-tygatec-t6-off-road-suv-hoverboard-carbon-black":
                "pre-book-tygatec-t6-hoverboard",
            "pre-book-tygatec-t6-plus-off-road-suv-hoverboard-app-connectivity-black-color":
                "pre-book-tygatec-t6-plus-hoverboard",
            "pre-book-tygatec-t6-plus-off-road-suv-hoverboard-app-connectivity-carbon-black":
                "pre-book-tygatec-t6-plus-hoverboard",
            "pre_book-tygatec-t6-plus-off-road-suv-hoverboardapp-connectivity-blue-galaxy-color":
                "pre-book-tygatec-t6-plus-hoverboard",
            "pre-booki-tygatec-t6-off-road-suv-hoverboard-blue-military-color":
                "pre-book-tygatec-t6-hoverboard",
            "pre-book-tygatec-t6-off-road-suv-hoverboard-blue-galaxy-color":
                "pre-book-tygatec-t6-hoverboard",
            "tygatec-t6-plus-off-road-suv-hoverboard-app-connectivity-red-and-blue-fire-color":
                "pre-book-tygatec-t6-plus-hoverboard",
            "pre-book-tygatec-t6-off-road-suv-hoverboard-white-multi-color":
                "pre-book-tygatec-t6-hoverboard",
            "pre-book-tygatec-t6-plus-off-road-suv-hoverboard-app-connectivity-blue-military-color":
                "pre-book-tygatec-t6-plus-hoverboard",
            "pre-book-tygatec-t6-plus-off-road-suv-hoverboard-app-connectivity-white-multi-color":
                "pre-book-tygatec-t6-plus-hoverboard",
            "pre-book-tygatec-t6-off-road-suv-hoverboard-ed-hardy-color":
                "pre-book-tygatec-t6-hoverboard",
            "pre-book-tygatec-t6-plus-off-road-suv-hoverboard-app-connectivity-red-fire-color":
                "pre-book-tygatec-t6-plus-hoverboard",
            "pre-book-tygatec-t6-off-road-suv-hoverboard-red-fire-color":
                "pre-book-tygatec-t6-hoverboard",
            "pre-book-tygatec-t6-plus-off-road-suv-hoverboardapp-connectivity-ed-hardy-color":
                "pre-book-tygatec-t6-plus-hoverboard",
        },
        t = [
            "tygatec-t9-3-wheel-electric-360-drift-scooter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-red-color",
            "tygatec-t9-3-wheel-electric-360-drift-scooter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-blue-color",
            "tygatec-t9-3-wheel-electric-360-drifter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-ed-hardy-color",
            "tygatec-t9-3-wheel-electric-360-drifter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-green-color",
            "tygatec-supersonic-high-speed-hobby-grade-remote-control-rc-car-stunt-car-color-green",
            "tygatec-supersonic-high-speed-remote-control-rc-car-hobby-grade-stunt-car-color-red",
            "tygatec-bolt-e-kick-electric-scooter-for-kids-adults-electric-foldable-scooter-new",
            "tygatec-sonic-e-kick-electric-scooter-for-kids-adults-pre",
            "pre-book-tygatec-t6-hoverboard",
            "pre-book-tygatec-t6-plus-hoverboard",
            "pre-booki-tygatec-t6-off-road-suv-hoverboard-blue-military-color",
            "pre-book-tygatec-t6-off-road-suv-hoverboard-blue-galaxy-color",
            "tygatec-t6-plus-off-road-suv-hoverboard-app-connectivity-red-and-blue-fire-color",
            "pre-book-tygatec-t6-off-road-suv-hoverboard-white-multi-color",
            "pre-book-tygatec-t6-plus-off-road-suv-hoverboard-app-connectivity-blue-military-color",
            "pre-book-tygatec-t6-plus-off-road-suv-hoverboard-app-connectivity-white-multi-color",
            "pre-book-tygatec-t6-off-road-suv-hoverboard-ed-hardy-color",
            "pre-book-tygatec-t6-plus-off-road-suv-hoverboard-app-connectivity-red-fire-color",
            "pre-book-tygatec-t6-off-road-suv-hoverboard-red-fire-color",
        ],
        n = [
            ".product-info__text",
            ".product__extra-box",
            ".product-watch",
            ".product-info__buy-buttons",
            ".video-call-sec",
            ".shopify-app-block",
            ".product-info__separator",
            ".accordionOffer__list",
            ".product-info__quantity-selector",
            ".min-bx-timer",
            ".product-info__liquid",
        ],
        o = {
            "tygatec-t9-3-wheel-electric-360-drift-scooter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-red-color":
                '<strong>Pre-book the T9 Drifter Now!</strong><br>Back in stock in 15 day.<br>Pay just ₹500 token amount to reserve.<br><span style="color: green; font-weight:600;">Get it for ₹19,499 instead of ₹20,499 – Only for pre-booking customers!</span>',
            "tygatec-t9-3-wheel-electric-360-drift-scooter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-blue-color":
                '<strong>Pre-book the T9 Drifter Now!</strong><br>Back in stock in 15 day.<br>Pay just ₹500 token amount to reserve.<br><span style="color: green; font-weight:600;">Get it for ₹19,499 instead of ₹20,499 – Only for pre-booking customers!</span>',
            "tygatec-t9-3-wheel-electric-360-drifter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-ed-hardy-color":
                '<strong>Pre-book the T9 Drifter Now!</strong><br>Back in stock in 15 day.<br>Pay just ₹500 token amount to reserve.<br><span style="color: green; font-weight:600;">Get it for ₹19,499 instead of ₹20,499 – Only for pre-booking customers!</span>',
            "tygatec-t9-3-wheel-electric-360-drifter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-green-color":
                '<strong>Pre-book the T9 Drifter Now!</strong><br>Back in stock in 15 days.<br>Pay just ₹500 token amount to reserve.<br><span style="color: green; font-weight:600;">Get it for ₹19,499 instead of ₹20,499 – Only for pre-booking customers!</span>',
            "tygatec-supersonic-high-speed-hobby-grade-remote-control-rc-car-stunt-car-color-green":
                '<strong>Pre-book the Supersonic Now!</strong><br>Back in stock in 90 days.<br>Pay just ₹500 token amount to reserve.<br><span style="color: green; font-weight:600;">Get it for ₹10,199 instead of ₹10,599 – Only for pre-booking customers!</span>',
            "tygatec-supersonic-high-speed-remote-control-rc-car-hobby-grade-stunt-car-color-red":
                '<strong>Pre-book the Supersonic Now!</strong><br>Back in stock in 30 days.<br>Pay just ₹500 token amount to reserve.<br><span style="color: green; font-weight:600;">Get it for ₹10,199 instead of ₹10,599 – Only for pre-booking customers!</span>',
            "tygatec-bolt-e-kick-electric-scooter-for-kids-adults-electric-foldable-scooter-new":
                '<strong>Pre-book the Bolt E-Scooter now!</strong><br>Back in stock in 15 days.<br>Pay just ₹500 as a token amount to reserve.<br><span style="color: green; font-weight:600;">Get it for ₹23,999 instead of ₹24,999 – Only for pre-booking customers!</span>',
            "tygatec-sonic-e-kick-electric-scooter-for-kids-adults-pre":
                '<strong>Pre-book the Sonic E-Scooter now!</strong><br>Back in stock in 15 days.<br>Pay just ₹500 as a token amount to reserve.<br><span style="color: green; font-weight:600;">Get it for ₹31,499 instead of ₹32,999 – Only for pre-booking customers!</span>',
            "pre-book-tygatec-t6-hoverboard":
                '<strong>Pre-book the T6 Hoverboard now!</strong><br>Back in stock in 10 days.<br>Pay just ₹500 as a token amount to reserve.<br><span style="color: green; font-weight:600;">Get it for ₹19,499 instead of ₹20,499 – Only for pre-booking customers!</span>',
            "pre-book-tygatec-t6-plus-hoverboard":
                '<strong>Pre-book the T6 Plus Hoverboard now!</strong><br>Back in stock in 10 days.<br>Pay just ₹500 as a token amount to reserve.<br><span style="color: green; font-weight:600;">Get it for ₹20,499 instead of ₹21,499 – Only for pre-booking customers!</span>',
        },
        c = {
            "tygatec-t9-3-wheel-electric-360-drift-scooter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-red-color":
                "46884768317696",
            "tygatec-t9-3-wheel-electric-360-drift-scooter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-blue-color":
                "46884768317697",
            "tygatec-t9-3-wheel-electric-360-drifter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-ed-hardy-color":
                "46884768317698",
            "tygatec-t9-3-wheel-electric-360-drifter-for-kids-and-adults-with-led-light-and-bluetooth-extreme-green-color":
                "46884768317699",
            "tygatec-supersonic-high-speed-hobby-grade-remote-control-rc-car-stunt-car-color-green":
                "46886968492288",
            "tygatec-supersonic-high-speed-remote-control-rc-car-hobby-grade-stunt-car-color-red":
                "46886968492289",
            "tygatec-bolt-e-kick-electric-scooter-for-kids-adults-electric-foldable-scooter-new":
                "46887000000000",
            "tygatec-sonic-e-kick-electric-scooter-for-kids-adults-pre":
                "46887000000001",
            "pre-book-tygatec-t6-hoverboard": "47060165296384",
            "pre-book-tygatec-t6-plus-hoverboard": "47065258459392",
        },
        l = window.location.pathname
            .split("/products/")[1]
            ?.split("?")[0]
            ?.trim(),
        a = e[l] || l;
    if (t.includes(a)) {
        let e = 0,
            l =
                document.querySelector(".product__info-container") ||
                document.querySelector(".product-form") ||
                document.querySelector("form[action*='/cart/add']");
        if (l && o[a]) {
            const e = document.createElement("div");
            e.classList.add("prebook-section");
            e.style.marginTop = "20px";

            const preInfo = document.createElement("div");
            preInfo.className = "pre-info";
            preInfo.style.cssText = "padding: 15px; background: #fffbf5; border: 1px solid #f2c97d; margin-bottom: 15px; font-size: 16px; line-height: 1.6; border-radius: 12px;";
            preInfo.innerHTML = o[a];

            const label = document.createElement("label");
            label.style.cssText = "font-size: 14px; display: flex; gap: 8px; align-items: center;";
            
            const checkbox = document.createElement("input");
            checkbox.type = "checkbox";
            checkbox.id = "prebook-checkbox";
            
            label.appendChild(checkbox);
            label.appendChild(document.createTextNode("I acknowledge booking amount is non-refundable"));
            preInfo.appendChild(label);

            const btn = document.createElement("button");
            btn.id = "prebooking-btn";
            btn.className = "btn btn--primary pre-booking-btn btn-fade";
            btn.style.cssText = "margin-top: 12px; display: block;";
            btn.disabled = true;
            btn.textContent = "Pre-Book Now for ₹500";

            const p = document.createElement("p");
            p.style.cssText = "color: red; font-size: 14px; margin-top: 8px; margin-bottom:15px;";
            p.textContent = "Pay ₹500 now to reserve. Remaining amount will be collected before dispatch.";

            e.appendChild(preInfo);
            e.appendChild(btn);
            e.appendChild(p);

            l.appendChild(e);
            const t = e.querySelector("#prebook-checkbox"),
                n = e.querySelector("#prebooking-btn");
            (t.addEventListener("change", function () {
                ((n.disabled = !this.checked),
                    n.classList.toggle("btn-fade", !this.checked));
            }),
                n.addEventListener("click", function () {
                    if (n.disabled) return;
                    const e = c[a];
                    if (e) {
                        window.location.href = `/cart/add?id=${e}&quantity=1`;
                    }
                }));
        }
    }
});
document.addEventListener("DOMContentLoaded", function () {
    var e = window.meta?.product || window.product,
        t = document.querySelector(".video-call-sec"),
        n = document.querySelector(".product-info__liquid");
    e &&
        "undefined" != typeof e.available &&
        (1 == e.available || "true" === e.available
            ? (t && (t.style.display = ""), n && (n.style.display = ""))
            : (t && (t.style.display = "none"),
              n && (n.style.display = "none")));
});
document.addEventListener("DOMContentLoaded", function () {
    const e = document.getElementById("ajax-form1"),
        t = document.querySelectorAll(".select-time");
    (t.forEach((e) => {
        e.addEventListener("click", function () {
            (t.forEach((e) => e.classList.remove("active")),
                this.classList.add("active"));
        });
    }),
        e.addEventListener("submit", async function (n) {
            n.preventDefault();
            const o = document.querySelector(".select-time.active");
            if (!o) return;
            const c =
                document.querySelector("h1.product__title") ||
                document.querySelector(".product-title") ||
                document.querySelector("meta[property='og:title']");
            let l = "Unknown Product";
            c
                ? c.textContent
                    ? (l = c.textContent.trim())
                    : c.getAttribute("content") &&
                      (l = c.getAttribute("content").trim())
                : window.location.href.includes("/products/") &&
                  (l = decodeURIComponent(
                      window.location.href
                          .split("/products/")[1]
                          .replace(/[-_]/g, " "),
                  ));
            const a = {
                name: e.name.value.trim(),
                email: e.email.value.trim(),
                phone: e.phone.value.trim(),
                date: e.date.value.trim(),
                time: o.dataset.time,
                page_url: window.location.href,
                product_name: l,
            };
            const d =
                "https://script.google.com/macros/s/AKfycbz6IjjNWcs-T4B4uG0sZFWI15PP-p17v6uCb5Yu-7GSMgnYCkf8i24CDSCXVgoVgWY/exec";
            try {
                (await fetch(d, {
                    method: "POST",
                    mode: "no-cors",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(a),
                }),
                    e.reset(),
                    t.forEach((e) => e.classList.remove("active")));
            } catch (e) {
            }
        }));
});

// ------- show more button ------
